import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-750dfee3")

_pushScopeId("data-v-750dfee3")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "r-grid container" }, [
  /*#__PURE__*/_createVNode("h2", null, "New Request")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createTextVNode(" Leave Type "),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*")
], -1)
const _hoisted_3 = {
  key: 0,
  value: "workday"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createTextVNode(" Duration "),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("option", { value: "full_day" }, "Full Day", -1)
const _hoisted_6 = {
  key: 0,
  value: "half_day"
}
const _hoisted_7 = {
  key: 1,
  value: "custom"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createTextVNode(" Hours "),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*")
], -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createTextVNode(" Minutes "),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("label", null, "Comment", -1)
const _hoisted_11 = {
  key: 0,
  class: "disclaimer"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", null, "Total Dates Requested:", -1)
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { key: 4 }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", null, "Leave Type:", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("label", null, "Duration Type:", -1)
const _hoisted_19 = { key: 5 }
const _hoisted_20 = { key: 6 }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", null, "Dates:", -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "button-group" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DateRange = _resolveComponent("DateRange")!
  const _component_Button = _resolveComponent("Button")!
  const _component_GroupContainer = _resolveComponent("GroupContainer")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.summaryScreen === false)
      ? (_openBlock(), _createBlock(_component_GroupContainer, { key: 0 }, {
          default: _withId(() => [
            _createVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.hours()), ["prevent"])),
              "aria-label": "create a new leave request"
            }, [
              _createVNode(_component_DateRange, {
                startDate: _ctx.newRequest.start_date,
                endDate: _ctx.newRequest.end_date,
                startDateRequired: true,
                endDateRequired: true,
                onStartDateChanged: _ctx.startDateChanged,
                onEndDateChanged: _ctx.endDateChanged
              }, null, 8, ["startDate", "endDate", "onStartDateChanged", "onEndDateChanged"]),
              _hoisted_2,
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newRequest.type = $event)),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.leaveChange())),
                required: ""
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.leaveTypesData, (type, index) => {
                  return (_openBlock(), _createBlock("option", {
                    key: index,
                    value: type.type
                  }, _toDisplayString(type.display_title), 9, ["value"]))
                }), 128)),
                (_ctx.workday)
                  ? (_openBlock(), _createBlock("option", _hoisted_3, "Workday"))
                  : _createCommentVNode("", true)
              ], 544), [
                [_vModelSelect, _ctx.newRequest.type]
              ]),
              _hoisted_4,
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newRequest.duration_type = $event)),
                required: ""
              }, [
                _hoisted_5,
                (_ctx.allowHalfDayType)
                  ? (_openBlock(), _createBlock("option", _hoisted_6, "Half Day"))
                  : _createCommentVNode("", true),
                (_ctx.allowCustomType)
                  ? (_openBlock(), _createBlock("option", _hoisted_7, "Custom"))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vModelSelect, _ctx.newRequest.duration_type]
              ]),
              (_ctx.newRequest.duration_type === 'custom')
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_8,
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.newRequest.hours = $event)),
                      min: "0",
                      max: "24",
                      name: "hours",
                      type: "number",
                      step: "1",
                      onKeypress: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.wholeNumber && _ctx.wholeNumber(...args))),
                      placeholder: "Hours",
                      required: ""
                    }, null, 544), [
                      [_vModelText, _ctx.newRequest.hours]
                    ]),
                    _hoisted_9,
                    _withDirectives(_createVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.newRequest.minutes = $event)),
                      name: "minutes",
                      placeholder: "Minutes",
                      required: ""
                    }, [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList([0, 15, 30, 45], (number, index) => {
                        return _createVNode("option", {
                          key: index,
                          value: number,
                          selected: number === 0
                        }, _toDisplayString(number), 9, ["value", "selected"])
                      }), 64))
                    ], 512), [
                      [_vModelSelect, _ctx.newRequest.minutes]
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_10,
              _withDirectives(_createVNode("textarea", {
                class: "comment",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.newRequest.comment = $event)),
                type: "text",
                placeholder: "",
                maxlength: "512"
              }, null, 512), [
                [_vModelText, _ctx.newRequest.comment]
              ]),
              _createVNode(_component_Button, {
                text: "Continue to Summary",
                type: "submit",
                disabled: _ctx.isHRAdminReadOnly && _ctx.$route.name === 'View/Edit User'
              }, null, 8, ["disabled"])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.summaryScreen && _ctx.hoursData)
      ? (_openBlock(), _createBlock(_component_GroupContainer, {
          key: 1,
          class: "summary-container",
          heading: "Summary"
        }, {
          default: _withId(() => [
            (_ctx.conflict)
              ? (_openBlock(), _createBlock("span", _hoisted_11, " * There are conflicting date(s) marked in red. Conflicting date(s) will be skipped and not submited. "))
              : _createCommentVNode("", true),
            (_ctx.uin)
              ? (_openBlock(), _createBlock("label", _hoisted_12, "UIN:"))
              : _createCommentVNode("", true),
            (_ctx.uin)
              ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.uin), 1))
              : _createCommentVNode("", true),
            _hoisted_14,
            _createVNode("span", null, _toDisplayString(_ctx.totalLeaves), 1),
            (_ctx.userInfoData.leaves_value_type === 'Hours')
              ? (_openBlock(), _createBlock("label", _hoisted_15, "Total Hours:"))
              : _createCommentVNode("", true),
            (_ctx.userInfoData.leaves_value_type === 'Hours')
              ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.totalHours), 1))
              : _createCommentVNode("", true),
            _hoisted_17,
            _createVNode("span", null, _toDisplayString(_ctx.parseLeaveTypes(_ctx.newRequest.type)), 1),
            _hoisted_18,
            _createVNode("span", null, _toDisplayString(_ctx.parseDurationType(_ctx.newRequest.duration_type)), 1),
            (_ctx.newRequest.comment)
              ? (_openBlock(), _createBlock("label", _hoisted_19, "Comment:"))
              : _createCommentVNode("", true),
            (_ctx.newRequest.comment)
              ? (_openBlock(), _createBlock("span", _hoisted_20, _toDisplayString(_ctx.newRequest.comment), 1))
              : _createCommentVNode("", true),
            _hoisted_21,
            _createVNode("ol", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hoursData, (item, index) => {
                return (_openBlock(), _createBlock("li", {
                  key: index,
                  class: ["date", { 'conflict': item.conflict }]
                }, [
                  _createTextVNode(_toDisplayString(item.date) + " ", 1),
                  (item.conflict === false && _ctx.userInfoData.leaves_value_type === 'Hours')
                    ? (_openBlock(), _createBlock("dt", _hoisted_22, _toDisplayString(item.hours) + " Hours ", 1))
                    : (item.conflict === true)
                      ? (_openBlock(), _createBlock("dd", _hoisted_23, _toDisplayString(item.conflictReason) + " * ", 1))
                      : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode(_component_Button, {
                text: "Return to Edit",
                type: "submit",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancel()))
              }),
              _createVNode(_component_Button, {
                text: `Confirm & Submit Request (${_ctx.totalLeaves} Days / ${_ctx.totalHours} Hours)`,
                type: "submit",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.newRequestSubmit($event))),
                async: true
              }, null, 8, ["text"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
})